import React from "react";
import CarDetail from "../carbookstatus/carDetail";
import TripDetail from "../../../pages/myBooking/tripStatus/mainTripDetail";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BookingTripCar from "./bookingTripCar";

const bookingContent = () => {
  return (
    <div className="main-content-booking-right verification-wrap">
      {" "}
      <div className="top-content">
        <div className="title">My Bookings</div>
      </div>
      <div className="bottom-content">
       <BookingTripCar />
       <BookingTripCar />
        {/* <Row className="content mt-5">
          <Col md={9} className="px-0">
            <TripDetail />
          </Col>
          <Col md={3} className="pb-3 car-col">
            <CarDetail />
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

export default bookingContent;
